import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNativeFeatureEnabled } from 'mini-host-bridge/lib/utils/isNativeFeatureEnabled';

export default function isNativeModuleSwitcherEnabled() {
    return (
        isMiniHostAppFeatureEnabled('nativeModuleSwitcher') &&
        isNativeFeatureEnabled('native-module-switcher')
    );
}
